module.exports = __webpack_public_path__ + "img/team-type.6efc7a8c.png";